export enum SupportRoutePathsEnum {
  SUPPORT = '/support',
}

export type SupportReferenceType = 'account' | 'transaction'

export type SupportLocationState = {
  supportReference?: {
    id: number
    label: string
    type: SupportReferenceType
    secondary?: string | null
  }
}
